import { makeStyles } from '@fluentui/react-components';

export const useSharedStyles = makeStyles({
    itemIcon: {
        color: '#000000',
        fill: 'transparent',
    },
});
